import { Component, OnInit } from '@angular/core';
import { FeeTypesService, FeeTypeDTO } from '../../../services/fee-types.service';
import { LoadingService } from '../../../services/loading.service';
import { AuditInfo } from '../../../interfaces/audit.interfaces';

@Component({
  selector: 'app-fee-types',
  templateUrl: './fee-types.component.html',
  styleUrls: ['./fee-types.component.scss']
})
export class FeeTypesComponent implements OnInit {
  feeTypes: FeeTypeDTO[] = [];
  filteredFeeTypes: FeeTypeDTO[] = [];

  searchTerm: string = '';

  constructor(
    private feeTypesService: FeeTypesService,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.loadFeeTypes();
  }

  private loadFeeTypes(): void {
    this.loadingService.show();
    this.feeTypesService.getAll().subscribe({
      next: (response: any) => {
        // Manejar estructura paginada: data puede ser array directo o {data: [...], totalCount: ...}
        const data = response?.data;
        this.feeTypes = Array.isArray(data) ? data : (data?.data || []);
        this.filteredFeeTypes = [...this.feeTypes];
        this.loadingService.hide();
      },
      error: (err) => {
        console.error(err);
        this.loadingService.hide();
      }
    });
  }

  applyFilters(): void {
    const search = this.searchTerm.toLowerCase();
    this.filteredFeeTypes = this.feeTypes.filter(feeType =>
      feeType.name.toLowerCase().includes(search) ||
      (feeType.description && feeType.description.toLowerCase().includes(search))
    );
  }

  getAuditData(feeType: FeeTypeDTO): AuditInfo {
    const anyFeeType = feeType as any;
    return {
      createdBy: anyFeeType?.createdBy,
      createdAt: anyFeeType?.createdAt,
      updatedBy: anyFeeType?.updatedBy,
      updatedAt: anyFeeType?.updatedAt,
      deletedBy: anyFeeType?.deletedBy,
      deletedAt: anyFeeType?.deletedAt,
      isDeleted: anyFeeType?.isDeleted
    };
  }
}
